import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Col, Row } from 'react-flexbox-grid';
import { records as jobsRecords } from '@saucelabs/sl-module-jobs';
import { JobCard } from '@saucelabs/sl-component-job-card';
import { GroupByDate } from '@saucelabs/sl-component-group-by-date';

import SeeAllButton from './SeeAllButton';
import RenderResults from './RenderResults';
import { JOB_TYPES, NAVIGATION_EVENTS, trackEvent } from './../tracking';
import Styles from './List.styles';

const AutomatedJobs = ({ jobs, isOpenSauceUser, showSeeAllButton, selectedPerfOption }) => (
  <Row>
    <Col xs={12}>
      <div className={Styles.list}>
        <RenderResults size={jobs.size}>
          <GroupByDate datePath={(item) => item.props.job.get('creation_time')}>
            {jobs.map((job) => (
              <JobCard
                key={job.id}
                isOwnerOpenSauce={isOpenSauceUser}
                job={job}
                onClick={() => trackEvent(
                  NAVIGATION_EVENTS.VIEW_JOB_DETAILS,
                  { type: JOB_TYPES.AUTOMATED },
                )}
                selectedPerfOption={selectedPerfOption}
              />
            ))}
          </GroupByDate>
        </RenderResults>
        {showSeeAllButton && <SeeAllButton />}
      </div>
    </Col>
  </Row>
);

AutomatedJobs.propTypes = {
  isOpenSauceUser: PropTypes.bool,
  jobs: ImmutablePropTypes.listOf(
    ImmutablePropTypes.recordOf(jobsRecords.JobRecordClass).isRequired,
  ).isRequired,
  selectedPerfOption: PropTypes.string,
  showSeeAllButton: PropTypes.bool,
};

AutomatedJobs.defaultProps = {
  isOpenSauceUser: false,
  selectedPerfOption: null,
  showSeeAllButton: true,
};

export default AutomatedJobs;
